import { getDomainCfg } from "../core/state";
import { getCloudUser } from "./cloudstorage/cloud";
import { userHasRole } from "./cloudstorage/user";

export const solutionDataRestricted = () : boolean => {
  const solutionRestricted = false;
  const restrictions = getDomainCfg().viewSettings.projectRestrictionSettings;
  if (restrictions !== undefined && restrictions.solutionRestricted) {   
    if (getCloudUser().loggedIn) {
      return userAccessRestricted();
    }

    return true;
  }
  return solutionRestricted;
}

export const solutionProjectRestricted = (projectId : string) : boolean => {
  if (restrictionSuffixConfigured(projectId)) {
    if (getCloudUser().loggedIn) {
      return userAccessRestricted();
    }

    return true;
  }

  return false;
}

const restrictionSuffixConfigured = (projectId : string) : boolean => {
  const restrictions = getDomainCfg().viewSettings.projectRestrictionSettings;
  let suffixRestricted = false;
  if (restrictions !== undefined && restrictions.suffix !== undefined) {
    suffixRestricted = (projectId.length > 4 && projectId.endsWith(restrictions.suffix));
  }
  return suffixRestricted;
}

const userAccessRestricted = () : boolean => {
  const restrictions = getDomainCfg().viewSettings.projectRestrictionSettings;
  const permittedRoles = restrictions.permittedUserRoles;
  let permitted = false;
  permittedRoles.forEach(role => {
    permitted = permitted || userHasRole(role);
  });
  return (permitted === false);
}
